import mockData from '../../../features/widget-team-scoreboard-list/fixtures/data.json';

export default function* generator() {
    yield mockData;
}
